module.exports = __webpack_public_path__ + "static/media/english-flag.137e0d8e.svg";